import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Picture\GetPictureFromDossierGalleryController::__invoke
* @see app/Http/Controllers/Dossier/Picture/GetPictureFromDossierGalleryController.php
* @route '/api/dossier/{dossier}/gallery/picture/{picture_id}'
*/
const GetPictureFromDossierGalleryController = (args: { dossier: string | number, picture_id: string | number | { id: string | number } } | [dossier: string | number, picture_id: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPictureFromDossierGalleryController.url(args, options),
    method: 'get',
})

GetPictureFromDossierGalleryController.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/gallery/picture/{picture_id}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\Picture\GetPictureFromDossierGalleryController::__invoke
* @see app/Http/Controllers/Dossier/Picture/GetPictureFromDossierGalleryController.php
* @route '/api/dossier/{dossier}/gallery/picture/{picture_id}'
*/
GetPictureFromDossierGalleryController.url = (args: { dossier: string | number, picture_id: string | number | { id: string | number } } | [dossier: string | number, picture_id: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            picture_id: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: args.dossier,
        picture_id: typeof args.picture_id === 'object'
        ? args.picture_id.id
        : args.picture_id,
    }

    return GetPictureFromDossierGalleryController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{picture_id}', parsedArgs.picture_id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Picture\GetPictureFromDossierGalleryController::__invoke
* @see app/Http/Controllers/Dossier/Picture/GetPictureFromDossierGalleryController.php
* @route '/api/dossier/{dossier}/gallery/picture/{picture_id}'
*/
GetPictureFromDossierGalleryController.get = (args: { dossier: string | number, picture_id: string | number | { id: string | number } } | [dossier: string | number, picture_id: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPictureFromDossierGalleryController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\Picture\GetPictureFromDossierGalleryController::__invoke
* @see app/Http/Controllers/Dossier/Picture/GetPictureFromDossierGalleryController.php
* @route '/api/dossier/{dossier}/gallery/picture/{picture_id}'
*/
GetPictureFromDossierGalleryController.head = (args: { dossier: string | number, picture_id: string | number | { id: string | number } } | [dossier: string | number, picture_id: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetPictureFromDossierGalleryController.url(args, options),
    method: 'head',
})

export default GetPictureFromDossierGalleryController